import React, { useState, useEffect } from 'react';

const MultiSelect = ({ element, formDataObject, setFormData, setChangedFormIds, setNormalFormIds, form,formData,validationErrors }) => {
  

  useEffect(() => {
    // Initialize formData with formDataObject for the specific field identified by element.selectedOption
    if (Object.keys(formData).length === 0 && formData.constructor === Object && formDataObject[element.selectedOption]) {
      setFormData({[element.selectedOption]:formDataObject[element.selectedOption] });
    }
  }, [formDataObject]);

  return (
    <>
      {element.elementType === "MultiSelectCheckbox" && (
        <div>
          {/* {element.isMandatory &&
                            !formData[element.selectedOption] &&
                            !formDataObject[element.selectedOption] && (
                              <span className="error-message">
                                *
                              </span>
                            )} */}
          {element.options.map((option) => (
            <div key={option}>
              <input
                type="checkbox"
                id={option}
                disabled={element.isReadOnly}
                name={element.selectedOption}
                checked={(formData[element.selectedOption]?.split(';').includes(option) || formDataObject[element.selectedOption]?.split(';').includes(option))}
                onChange={(e) => {
                  const { checked } = e.target;
                  const updatedOptions = checked
                    ? [...(formData[element.selectedOption]?.split(';') || []), option]
                    : formData[element.selectedOption]?.split(';').filter((item) => item !== option);
                  
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    [element.selectedOption]: updatedOptions.join(';'),
                  }));
                  
                  setChangedFormIds((prevChangedFormIds) => (
                    !prevChangedFormIds.includes(form?.id) ? [...prevChangedFormIds, form?.id] : prevChangedFormIds
                  ));

                  setNormalFormIds((prevNormalFormIds) => (
                    !prevNormalFormIds.includes(form?.id) ? [...prevNormalFormIds, form?.id] : prevNormalFormIds
                  ));
                }}
              />
              <label >{option}</label>
            </div>
          ))}
           {validationErrors[element.selectedOption] && (
          <div className="error-message">
            {validationErrors[element.selectedOption]}
          </div>
        )}
          {/* <p>Selected Options: {formData[element.selectedOption]?.split(';').join(', ')}</p> */}
        </div>
        
      )}
    </>
  );
};

export default MultiSelect;
